export default __webpack_public_path__ + "static/media/sortIconDown.0b60e2b3.svg";